import { create } from "zustand";

interface UIStore {
   isMobileSidebarOpen: boolean;
   isSidebarCollapsed: boolean;
   openMobileSidebar: () => void;
   closeMobileSidebar: () => void;
   toggleMobileSidebar: () => void;
   toggleSidebarCollapsed: () => void;
   setSidebarCollapsed: (collapsed: boolean) => void;
}

export const useUIStore = create<UIStore>((set) => ({
   isMobileSidebarOpen: false,
   isSidebarCollapsed: false,
   openMobileSidebar: () => set({ isMobileSidebarOpen: true }),
   closeMobileSidebar: () => set({ isMobileSidebarOpen: false }),
   toggleMobileSidebar: () =>
      set((state) => ({ isMobileSidebarOpen: !state.isMobileSidebarOpen })),
   toggleSidebarCollapsed: () =>
      set((state) => ({ isSidebarCollapsed: !state.isSidebarCollapsed })),
   setSidebarCollapsed: (collapsed: boolean) =>
      set({ isSidebarCollapsed: collapsed }),
}));
